import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type QuoteRequestProcessStepsDto = ClientInferResponseBody<
  typeof contract.quoteRequests.findProcessSteps
>;

export const fetchProcessSteps = async (
  id: string,
): Promise<QuoteRequestProcessStepsDto | null> => {
  const response = await api.quoteRequests.findProcessSteps.query({
    params: { id },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
